export enum SocketEvent {
  WAITER_ACCEPT_ORDER = "WAITER_ACCEPT_ORDER",
  WAITER_SEND_CONFIRM_ORDER = "WAITER_SEND_CONFIRM_ORDER",
  // WAITER_RECEIVE_ORDER_FROM_CUSTOMER = "WAITER_RECEIVE_ORDER_FROM_CUSTOMER",
  WAITER_SUPPORT_CUSTOMER = "WAITER_SUPPORT_CUSTOMER",
  WAITER_RECEIVE_CONFIRM_ORDER = "WAITER_RECEIVE_CONFIRM_ORDER",
  WAITER_RECEIVE_PAYMENT = "WAITER_RECEIVE_PAYMENT",
  WAITER_RECEIVE_TABLE_COLORS_STATUS_TRACKING = "WAITER_RECEIVE_TABLE_COLORS_STATUS_TRACKING",
  WAITER_RECEIVE_STATUS_TRACKING_ORDER = "WAITER_RECEIVE_STATUS_TRACKING_ORDER",
  CUSTOMER_RECEIVE_ORDER_STATUS_FROM_WAITER = "CUSTOMER_RECEIVE_ORDER_STATUS_FROM_WAITER",
  // WAITER_REJECTED_ORDER = "CHEF_ACTION_ORDER",
  WAITER_RECEIVE_PICK_UP_FOOD = "WAITER_RECEIVE_PICK_UP_FOOD",
  WAITER_RECEIVE_PROCESSING_FOOD = "WAITER_RECEIVE_PROCESSING_FOOD",
  WAITER_RECEIVE_PENDING_FOOD = "WAITER_RECEIVE_PENDING_FOOD",

  WAITER_CREATE_ORDER = "staff:order:create",
  CHEF_ACTION_ORDER = "CHEF_ACTION_ORDER",

  WAITER_RECEIVE_ORDER_FROM_CUSTOMER = "order:created",
  NOTIFICATION_READ = "table:notification_read",
  FREE_ITEM_REQUEST = "order:free_item:requested",

  REJECT_ORDER = "order:rejected", //2
  ACCEPT_ORDER = "order:accepted", //3
  COOK_ORDER = "order:cooked", //4
  READy_ORDER = "order:ready", //5
  DONE_ORDER = "order:done", //6
  RETURN_ORDER = "order:returned", //7
}

export enum OrderEvent {
  RECEIVED_ORDER_STATUS = "CUSTOMER_RECEIVE_ORDER_STATUS_FROM_WAITER",
}
